import { useQuery } from '@tanstack/react-query';

import { apiRequest } from '../api/client';
import { useSessionStore } from './session-store';

export interface CurrentUser {
  id: string;
  email: string;
  fullName: string;
  roleCodes: string[];
  permissions: string[];
  totpEnabled: boolean;
  mustEnrollTotp: boolean;
  /** Staff vs. customer account. A customer account must not use the back-office. */
  isInternal: boolean;
}

/** Backs the header identity and the second factor banner alike. */
export function useCurrentUser() {
  const isAuthenticated = useSessionStore((state) => state.isAuthenticated());

  return useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      const profile = await apiRequest<CurrentUser>('/auth/me');

      // An older API response may not carry `permissions` yet; defaulting to
      // an empty array here keeps every downstream `hasPermission` check safe
      // without threading `| undefined` through the whole app.
      return { ...profile, permissions: profile.permissions ?? [] };
    },
    enabled: isAuthenticated,
  });
}
